import React, { useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import Character from '../../assets/Character.png';
import api from '../api';
import { useHistory } from 'react-router';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EditReservasiCode(props) {
    const history = useHistory()
    const [reservationCode, setReservationCode] = useState(null)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);

    const [errorKode, setErrorKode] = React.useState(false);
    const [texterrorKode, setTextErrorKode] = React.useState(null);

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }


    React.useEffect(() => {
    }, [])

    const doSubmit = (e) => {
        if (reservationCode === null || reservationCode === '') {
            setErrorKode(true)
            setTextErrorKode("Kode wajib diisi")
        } else {
            let payload = {
                "booking_id": reservationCode,
                "is_billing": 1
            }
            console.log(JSON.stringify(payload));
            api.create().findCode(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (props.intent === "list") {
                            history.push({
                                pathname: '/pembayaran/detail-tagihan',
                                name: 'Pembayaran - Input Tagihan',
                                search: '',  // query string
                                state: {  // location state
                                    data: response.data.data
                                },
                            })
                        } else {
                            props.setData(response.data.data)
                            props.onClose()
                        }
                    } else {
                        if (response.data.data) {
                            setOpenAlert(true)
                            setMessageAlert(response.data.data)
                            setStatusAlert("Warning")
                        }
                    }
                }
            })
        }

    }


    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content-very-low background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tagihan Pembayaran</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ margin: 'auto', backgroundColor: 'transparent', padding: 20 }}>
                    <img src={Character} style={{ width: 180, height: 152, marginTop: 3 }} />
                    <Typography style={{ fontSize: 15, marginTop: 20, marginBottom: 10 }}>Input Kode Reservasi Pasient</Typography>
                    <TextField
                        required={true}
                        style={{ width: 297, height: 42 }}
                        InputProps={{
                            style: {
                                borderRadius: 10,
                                
                            }
                        }}
                        inputProps={{
                            style: {
                                padding: 10,
                                textAlign: 'center'
                            }
                        }}
                        FormHelperTextProps={{ style: {alignSelf: 'center'}}}
                        error={errorKode}
                        helperText={texterrorKode}
                        id="outlined-basic"
                        variant="outlined"
                        onChange={(e) => {
                            setReservationCode(e.target.value)
                            setErrorKode(false)
                            setTextErrorKode(null)
                        }}
                    />

                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 10, paddingBottom: 40 }}>
                    <div onClick={(e) => doSubmit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <Typography style={{ color: 'white', fontSize: 15, padding: 5 }}>Lanjut</Typography>
                    </div>
                </div>
            </div>
        </div>
    )
}